<template>
  <div class="users-list">
    <template v-for="user in users">
      <UserItem
        v-if="shouldShowItem(user.selected)"
        :key="user._id"
        :id="user._id"
        :name="user.name"
        :position="user.position"
        :selected="user.selected"
        :coaching="user.coaching"
        :limit="user.limit"
        :coachingText="coachingText"
        :ofText="ofText"
        :account="user"
        @userClicked="$emit('userClicked', user)"
      />
    </template>
    <EmptyState
      v-if="isShowingUsers"
      class="py-14"
      :icon="'mdi-bee'"
      :iconSize="48"
      :title="$t('common.nothing_to_see_here')"
      :message="$t('common.users.empty_state_subtitle')"
    />
  </div>
</template>

<script>
import UserItem from './UserItem.vue'
import EmptyState from '@/components/EmptyState.vue'

export default {
  name: 'UserList',
  components: {
    UserItem,
    EmptyState,
  },
  props: {
    users: {
      type: Array,
      required: true,
    },
    coachingText: {
      type: String,
      required: false,
    },
    ofText: {
      type: String,
      required: false,
    },
    showSelection: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  computed: {
    isShowingUsers() {
      if (this.showSelection) return this.users.length < 1
      const nonSelectedUsers = this.users.filter(user => !user.selected)
      return nonSelectedUsers.length < 1
    },
  },

  methods: {
    shouldShowItem(isSelected) {
      if (this.showSelection) return true
      return !this.showSelection && !isSelected
    },
  },
}
</script>
<style lang="scss" scoped>
.users-list {
  height: 252px;
  overflow-y: auto;
}
</style>
